var data = {
  table: {
    // TODO: デフォルトは非表示、実装始まり次第復活させる
    // project: ['プロジェクト名', 'カラー', '稼働量/上限(月)', 'メンバー'],
    project: ['プロジェクト名', 'カラー'],
  },
  input: {
    validation: {
      // 半角英数字3文字以上、-と_のみ使用可能
      screen_name: '^([0-9A-Za-z_-]{3,})$',
    },
  },
  template: {
    defaultDuration: '01:00',
    duration: [
      {label: '15分', duration: '00:15'},
      {label: '30分', duration: '00:30'},
      {label: '1時間', duration: '01:00'},
      {label: '1.5時間', duration: '01:30'},
      {label: '2時間', duration: '02:00'},
      {label: '2.5時間', duration: '02:30'},
      {label: '3時間', duration: '03:00'},
    ],
  },
  project: {
    disabledColor: '#B9B9C9',
    recommend_colors: [
      '#A20019',
      '#0070A3',
      '#A37D00',
      '#1EA300',
      '#6A00A3',
      '#00A39E',
      '#A30088',
    ],
  },
};

module.exports = data;